import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

interface FooterProps {
  newsletterSubmitAddr: string;
}

export default function Footer({ newsletterSubmitAddr }: FooterProps) {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <h3 className="text-lg font-heading font-bold text-background-50 mb-4">乳色吐息动漫</h3>
            <p className="text-sm text-background-400 leading-relaxed">
              最全面的乳色吐息动漫粉丝内容平台。提供剧情解析、角色介绍、观看指南与原创评测，为每一位热爱这部作品的朋友打造温暖的内容家园。
            </p>
          </div>

          <div>
            <h3 className="text-lg font-heading font-bold text-background-50 mb-4">内容分类</h3>
            <div className="grid grid-cols-2 gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-lg font-heading font-bold text-background-50 mb-4">订阅更新</h3>
            <p className="text-sm text-background-400 mb-3">
              订阅我们的邮件通讯，第一时间获取最新文章与动漫资讯。
            </p>
            <form
              action={newsletterSubmitAddr}
              method="POST"
              className="flex flex-col sm:flex-row gap-2"
              data-readdy-form="true"
            >
              <div className="form-hp-wrap">
                <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>
              <input
                type="email"
                name="email"
                placeholder="输入您的邮箱"
                required
                className="flex-1 px-4 py-2.5 text-sm rounded-lg bg-background-800 text-background-100 placeholder:text-background-500 border border-background-700 focus:outline-none focus:border-primary-500 transition-colors"
              />
              <button
                type="submit"
                className="px-5 py-2.5 text-sm rounded-lg bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                订阅
              </button>
            </form>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 乳色吐息动漫粉丝站. 本站为粉丝内容平台，与官方制作方无直接关联。
          </p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="text-xs text-background-500 hover:text-background-200 transition-colors whitespace-nowrap">
              关于我们
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}